'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ELEMENT_EDIT_START = exports.ELEMENT_EDIT_START = 'ELEMENT_EDIT_START';
var ELEMENT_SET_EDIT_HANDLER = exports.ELEMENT_SET_EDIT_HANDLER = 'ELEMENT_SET_EDIT_HANDLER';
var ELEMENT_EDIT_COMPLETE = exports.ELEMENT_EDIT_COMPLETE = 'ELEMENT_EDIT_COMPLETE';

// Selection action types
var ELEMENTS_SELECTED = exports.ELEMENTS_SELECTED = 'ELEMENTS_SELECTED';
var ELEMENTS_DESELECTED = exports.ELEMENTS_DESELECTED = 'ELEMENTS_DESELECTED';
var ELEMENTS_DESELECT_ALL = exports.ELEMENTS_DESELECT_ALL = 'ELEMENTS_DESELECT_ALL';


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/selectionConstants.js
// module id = 77
// module chunks = 0